import Vue from 'vue'
import Router from 'vue-router'

import InvitationStudent from '@/views/invitation/student/InvitationStudent'
import InvitationStudentInfo from '@/views/invitation/student/InvitationStudentInfo'
import InvitationStudentRecord from '@/views/invitation/student/InvitationStudentRecord'

import InvitationTeacherInfo from '@/views/invitation/teacher/InvitationTeacherInfo'
import InvitationTeacherRecord from '@/views/invitation/teacher/InvitationTeacherRecord'
import InvitationTeacher from '@/views/invitation/teacher/InvitationTeacher'
import InvitationStudentJoinClass from '@/views/invitation/teacher/InvitationStudentJoinClass'

import NoviceGuide from '@/components/NoviceGuide'
import AboutClass from '@/components/AboutClass'
import AboutAuth from '@/components/AboutAuth'
import AboutPass from '@/components/AboutPass'
import AboutBook from '@/components/AboutBook'
import AboutCourse from '@/components/AboutCourse'
import AboutOther from '@/components/AboutOther'

import NoviceGuideStudent from '@/components/NoviceGuideStudent'
import AboutStudentBook from '@/components/AboutStudentBook'
import AboutStudentClass from '@/components/AboutStudentClass'
import AboutStudentPass from '@/components/AboutStudentPass'
import AboutStudentMember from '@/components/AboutStudentMember'
import AboutStudentCourse from '@/components/AboutStudentCourse'
import AboutStudentOther from '@/components/AboutStudentOther'
import AboutYueban from '@/components/AboutYueban'

import QuestionDetail from '@/components/QuestionDetail'

import Feedback from '@/components/Feedback'

import DownloadStudent from '@/views/download/DownloadStudent'
import DownloadTeacher from '@/views/download/DownloadTeacher'

import CircleIntroduce from '@/views/circle/Introduce'
import TeachingVideo from '@/views/circle/TeachingVideo'

Vue.use(Router)

export default new Router({
  routes: [

    {path: '/inviteTeacherRecord', name: 'InvitationTeacherInfo', component: InvitationTeacherInfo},
    {path: '/invitationTeacherRecord', name: 'InvitationTeacherRecord', component: InvitationTeacherRecord},
    {path: '/inviteTeacher', name: 'InvitationTeacher', component: InvitationTeacher},
    {path: '/joinClass', name: 'InvitationStudentJoinClass', component: InvitationStudentJoinClass},
    
    {path: '/inviteStudent', name: 'InvitationStudent', component: InvitationStudent},
    {path: '/inviteStudentRecord', name: 'InvitationStudentInfo', component: InvitationStudentInfo},
    {path: '/invitationStudentRecord', name: 'InvitationStudentRecord', component: InvitationStudentRecord},

    {path: '/noviceGuide', name: 'NoviceGuide', component: NoviceGuide},
    {path: '/aboutClass', name: 'AboutClass', component: AboutClass},
    {path: '/aboutAuth', name: 'AboutAuth', component: AboutAuth},
    {path: '/aboutPass', name: 'AboutPass', component: AboutPass},
    {path: '/aboutCourse', name: 'AboutCourse', component: AboutCourse},
    {path: '/aboutOther', name: 'AboutOther', component: AboutOther},
    {path: '/aboutBook', name: 'AboutBook', component: AboutBook},

    {path: '/noviceGuideStudent', name: 'NoviceGuideStudent', component: NoviceGuideStudent},
    {path: '/aboutStudentClass', name: 'AboutStudentClass', component: AboutStudentClass},
    {path: '/aboutStudentMember', name: 'AboutStudentMember', component: AboutStudentMember},
    {path: '/aboutStudentPass', name: 'AboutStudentPass', component: AboutStudentPass},
    {path: '/aboutStudentCourse', name: 'AboutStudentCourse', component: AboutStudentCourse},
    {path: '/aboutStudentOther', name: 'AboutStudentOther', component: AboutStudentOther},
    {path: '/aboutStudentBook', name: 'AboutStudentBook', component: AboutStudentBook},
    {path: '/aboutYueban', name: 'AboutYueban', component: AboutYueban},

    {path: '/questionDetail', name: 'QuestionDetail', component: QuestionDetail},

    {path: '/feedback', name: 'Feedback', component: Feedback},

    {path: '/downloadStudent', name: 'DownloadStudent', component: DownloadStudent},
    {path: '/downloadTeacher', name: 'DownloadTeacher', component: DownloadTeacher},

    {path: '/circleIntroduce', name: 'CircleIntroduce', component: CircleIntroduce},
    {path: '/teachingVideo', name: 'TeachingVideo', component: TeachingVideo}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js